export class CodeTableMap {
	[ctName: string]: CodeTable[];
}

/* export class CodeTable {
	elementCode: string;
	elementDes: string;
	filter: string;
	ranking: number;
	optional: string;
} */


export interface CodeTable {
	elementCode?: string;
	elementDes?: string;
	filter?: string;
	groupCode?: string;
	idMarket?: string;
	ranking?: number;
}

export interface CTGroupDTO {
	description?: string;
	groupCode?: string;
}


export enum CT {
	COUNTRY,
	DEALER_ACTIVITY,
	CAR_SOLD,
	BUYING_INTEREST,
	ROLE,
	PERMISSION,
	MENU_BUYER,
	MENU_AUCTIONEER,
	MENU_LOADER,
	MENU_EXHIBITOR,
	MARKET,
	AUCTION_STATUS,
	LOT_STATUS,
	APPRAISAL,
	APPRAISAL_FORMAT,
	VEHICLE_FILTER,
	PRODUCT_TYPE,
	CHANNEL,
	COUNTRY_AREA,
	VEHICLE_SHOWCASE_STATE,
	EMAIL_TEMPLATE_TYPE,
	REPORT_TYPE,
	BRAND,
	LOT_SEARCH_STATUS,
	LANGUAGE,
	FUEL_TYPE_INFOCAR,
	FUEL_TYPE_JATO,
	USER_TEMPLATE_ENABLE
}
